import { FC } from 'react';

import { Step1 } from './Steps/Step1';
// import { Step2 } from './Steps/Step2';
// import { Step3 } from './Steps/Step3';
// import { Step4 } from './Steps/Step4';
// import { Step5 } from './Steps/Step5';
// import { Step6 } from './Steps/Step6';
// import { Completion } from '@/components/Completion';
import { Product } from '@/components/Product';
// import { useLocalStorage } from '@/hooks/useLocalStorage';
// import SuccessfulCompletion1 from '@/assets/successfulCompletion1.png';
import type { IProduct } from '@/types/product';

interface TrainingProps {
  step: number;
  setStep: (value: number) => void;
  product: IProduct;
  totalPoints: number;
}

const Training: FC<TrainingProps> = ({
  step,
  setStep,
  product,
  totalPoints,
}) =>
  // const [isTrainingCompleted, setIsTrainingCompleted] = useLocalStorage(
  //   'isTrainingCompleted',
  //   false,
  // );

  // useEffect(() => {
  //   if (isTrainingCompleted) {
  //     setStep(8);
  //   }
  // }, []);

  // const handleClick = () => {
  //   setStep(8);
  // };

   (
    <>
      {/* {!isTrainingCompleted && ( */}
        {/* <> */}
          {step === 1 && <Step1 setStep={setStep} totalPoints={totalPoints} />}
          {/* {step === 2 && <Step2 setStep={setStep} />}
          {step === 3 && <Step3 setStep={setStep} />}
          {step === 4 && <Step4 setStep={setStep} />}
          {step === 5 && <Step5 setStep={setStep} />}
          {step === 6 && <Step6 setStep={setStep} />}
          {step === 7 && (
            <Completion
              handleClick={handleClick}
              src={SuccessfulCompletion1}
              title="Обучение завершено"
              description="Вы успешно прошли обучение. Теперь Вы готовы к работе с посетителями магазина."
              buttonText="Продолжить"
            />
          )} */}
        {/* </> */}
      {/* )} */}
      {step === 8 && (
        <Product
          setStep={setStep}
          // setIsTrainingCompleted={setIsTrainingCompleted}
          setIsTrainingCompleted={() => {}}
          product={product}
        />
      )}
    </>
  )
;

export default Training;
